export default {
    pageName: 'Overview',
    search: {
        title: '',
        placeholder: 'Search by Bureau'
    },
    people: 'People',
    detail: {
        title: 'Information',
        present: 'Present',
        late: 'Late',
        halfDay: 'Half-day Absent',
        absent: 'Absent',
        leave: 'Leave'
    },
    header: {
        full: 'Bureau',
        sub: 'Bureau'
    }
}
